module.exports = __webpack_public_path__ + "static/media/icon-twitter.86ca2f00.svg";